import { render, staticRenderFns } from "./ImportPaymentsDetails.vue?vue&type=template&id=27803a66&scoped=true"
import script from "./ImportPaymentsDetails.vue?vue&type=script&lang=js"
export * from "./ImportPaymentsDetails.vue?vue&type=script&lang=js"
import style0 from "./ImportPaymentsDetails.vue?vue&type=style&index=0&id=27803a66&prod&lang=scss&scoped=true"
import style1 from "./ImportPaymentsDetails.vue?vue&type=style&index=1&id=27803a66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27803a66",
  null
  
)

export default component.exports